import { z } from "zod";

export const zodPathParam = z.string().refine(
	(v) => {
		return !/[/\\.]/.test(decodeURIComponent(v));
	},
	{
		message: 'Path parameters cannot contain "/", "." or "\\".',
	},
);
